/* eslint-disable */
// source: vivacity/core/detection_quality.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var vivacity_core_glare_analysis_pb = require('../../vivacity/core/glare_analysis_pb.js');
goog.object.extend(proto, vivacity_core_glare_analysis_pb);
goog.exportSymbol('proto.vivacity.core.DetectionQuality', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.core.DetectionQuality = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vivacity.core.DetectionQuality, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.core.DetectionQuality.displayName = 'proto.vivacity.core.DetectionQuality';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.core.DetectionQuality.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.core.DetectionQuality.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.core.DetectionQuality} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.DetectionQuality.toObject = function(includeInstance, msg) {
  var f, obj = {
    glareType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    glareIntensity: jspb.Message.getFieldWithDefault(msg, 2, 0),
    badDataAssumed: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    occlusionPct: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.core.DetectionQuality}
 */
proto.vivacity.core.DetectionQuality.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.core.DetectionQuality;
  return proto.vivacity.core.DetectionQuality.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.core.DetectionQuality} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.core.DetectionQuality}
 */
proto.vivacity.core.DetectionQuality.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.vivacity.core.GlareType} */ (reader.readEnum());
      msg.setGlareType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setGlareIntensity(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBadDataAssumed(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOcclusionPct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.core.DetectionQuality.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.core.DetectionQuality.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.core.DetectionQuality} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.DetectionQuality.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGlareType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getGlareIntensity();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getBadDataAssumed();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getOcclusionPct();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional GlareType glare_type = 1;
 * @return {!proto.vivacity.core.GlareType}
 */
proto.vivacity.core.DetectionQuality.prototype.getGlareType = function() {
  return /** @type {!proto.vivacity.core.GlareType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.vivacity.core.GlareType} value
 * @return {!proto.vivacity.core.DetectionQuality} returns this
 */
proto.vivacity.core.DetectionQuality.prototype.setGlareType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional uint32 glare_intensity = 2;
 * @return {number}
 */
proto.vivacity.core.DetectionQuality.prototype.getGlareIntensity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.DetectionQuality} returns this
 */
proto.vivacity.core.DetectionQuality.prototype.setGlareIntensity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool bad_data_assumed = 3;
 * @return {boolean}
 */
proto.vivacity.core.DetectionQuality.prototype.getBadDataAssumed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vivacity.core.DetectionQuality} returns this
 */
proto.vivacity.core.DetectionQuality.prototype.setBadDataAssumed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional uint32 occlusion_pct = 4;
 * @return {number}
 */
proto.vivacity.core.DetectionQuality.prototype.getOcclusionPct = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.DetectionQuality} returns this
 */
proto.vivacity.core.DetectionQuality.prototype.setOcclusionPct = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


goog.object.extend(exports, proto.vivacity.core);
